export default "__VITE_ASSET__BGw5Z1vH__"